import { Fragment } from 'react';

import { Analytics, OpenGraph, TwitterCards } from '@components/atoms';
import { TermsAndConditionsPageContent } from '@components/organisms';

const title = 'Terms and Conditions | Green Line Logistics';
const description =
  'Read the Green Line Logistics End-User License Agreement governing access to and use of the Green Line platform and services.';
const url = 'https://greenlinelog.com/terms-and-conditions';

function TermsAndConditionsPage() {
  return (
    <Fragment>
      <Analytics pageTitle={title}>
        <meta name="description" content={description} />

        <OpenGraph title={title} description={description} url={url} />
        <TwitterCards title={title} description={description} site={url} />
      </Analytics>

      <TermsAndConditionsPageContent />
    </Fragment>
  );
}

export default TermsAndConditionsPage;
